import React from 'react';
import BlogCard from '../components/BlogElements/BlogCard';

const BlogHome = () => {
    const BlogData = [
        {
            id: '1',
            img: 'images/blog/1.jpg',
            author: 'Dessert - By Zoyena Ross',
            title: 'Bread Jam Fusion',
        },
        {
            id: '2',
            img: 'images/blog/2.jpg',
            author: 'Dessert - By Jacob Johnson',
            title: 'How to start food vlog',
        },
        {
            id: '3',
            img: 'images/blog/3.jpg',
            author: 'Dessert - By Parker Noel',
            title: 'Fod serving art tips',
        },
        {
            id: '4',
            img: 'images/blog/4.jpg',
            author: 'Dessert - By Austin Ryan',
            title: 'Misnighr Snack Bars',
        },
    ];

    return (

        <div className="blog_grid section_sm home_blog">
            <div className="container">
                <div className="section_header">
                    <img src="images/title_back.png" alt="" />
                    <h2 className="section_title">Latest Food Blogs</h2>
                    <h6 className="section_sub_title">
                        Read our restaurant food blogs to get tips & tricks of cooking
                    </h6>
                </div>

                <div className="row">
                    {
                        BlogData.map(data => <BlogCard
                            key={data.id}
                            data={data}
                        />)
                    }
                </div>
            </div>
        </div>
    );
};

export default BlogHome;